import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Clientes from './pages/Clientes';
import NuevoCliente from './pages/NuevoCliente';
import MovimientosPage from './pages/Movimientos';
import HistoricoPage from './pages/Historico';
import DetallesMovimientosPage from './pages/DetallesMovimientos';
import Reservas from './pages/Reservas';
import Ventas from './pages/Ventas';
import Facturacion from './pages/Facturacion';
import Clima from './pages/Clima';
import Dashboard from './pages/Dashboard';
import DetallesClientesPage from './pages/DetallesClientes';
import HelpPage from './pages/HelpPage';
import Registros from './pages/Registros';
import { ToastContainer } from 'react-toastify';
import HistoricoMovimientosPage from './pages/HistoricoMovimientosPage';
import HistoricoRegistrosPage from './pages/HistoricoRegistrosPage';
import ConfiguracionPage from './pages/ConfiguracionPage';
import HistoricoVentasPorUsuarioPage from './pages/HistoricoVentasPorUsuarioPage';
import Guarderia from './pages/Guarderia';
import { api } from './lib/api';
import ModalPassword from './components/registrosIngresos/ModalPassword';

const AUTH_STORAGE_KEY = 'sensitiveRouteAuth';
const AUTH_WINDOW_MS = 1000 * 60 * 10;

const leerAutorizacion = () => {
  try {
    const raw = window.sessionStorage.getItem(AUTH_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.expiresAt || Date.now() > Number(parsed.expiresAt)) {
      window.sessionStorage.removeItem(AUTH_STORAGE_KEY);
      return null;
    }
    return parsed;
  } catch (error) {
    return null;
  }
};

const guardarAutorizacion = (autorizador) => {
  const payload = {
    autorizador,
    expiresAt: Date.now() + AUTH_WINDOW_MS,
  };
  window.sessionStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(payload));
};

const SensitiveRoute = ({ children }) => {
  const location = useLocation();
  const [estado, setEstado] = useState(() => (leerAutorizacion() ? 'ok' : 'pending'));
  const [pin, setPin] = useState('');
  const [errorPin, setErrorPin] = useState('');
  const [enviandoPin, setEnviandoPin] = useState(false);

  useEffect(() => {
    window.sessionStorage.removeItem(AUTH_STORAGE_KEY);

    setEstado('pending');
    setPin('');
    setErrorPin('');
    setEnviandoPin(false);
  }, [location.pathname]);

  const confirmarPin = async () => {
    const pinLimpio = pin.toString().trim();

    if (!pinLimpio) {
      setErrorPin('Ingresá el PIN de administrador.');
      return;
    }

    try {
      setEnviandoPin(true);
      setErrorPin('');

      const response = await api.post('/usuarios/verificar-autorizacion', {
        password: pinLimpio,
      });

      guardarAutorizacion(response?.data?.autorizador || null);
      setEstado('ok');
    } catch (error) {
      setErrorPin(error?.response?.data?.error || 'PIN inválido para acceso restringido.');
    } finally {
      setEnviandoPin(false);
    }
  };

  const cancelarPin = () => {
    setEstado('denied');
  };

  if (estado === 'pending') {
    return (
      <ModalPassword
        showPasswordModal
        ventaPendiente={null}
        password={pin}
        setPassword={setPin}
        enviandoVenta={enviandoPin}
        confirmarVentaConPassword={confirmarPin}
        onCancel={cancelarPin}
        title="Autorización de administrador"
        description="Ingresá el PIN para acceder a esta sección."
        details="Esta sección está protegida. Solo usuarios administradores pueden continuar."
        errorMessage={errorPin}
      />
    );
  }

  if (estado === 'denied') {
    return <Navigate to="/" replace />;
  }

  return children;
};

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/clientes" element={<Clientes />} />
        <Route path="/nuevocliente" element={<NuevoCliente />} />
        <Route path="/movimientos" element={<MovimientosPage />} />
        <Route path="/historico" element={<SensitiveRoute><HistoricoPage /></SensitiveRoute>} />
        <Route path="/detallesmovimientos" element={<DetallesMovimientosPage />} />
        <Route path="/reservas" element={<Reservas />} />
        <Route path="/ventas" element={<Ventas />} />
        <Route path="/facturacion" element={<Facturacion />} />
        <Route path="/clima" element={<Clima />} />
        <Route path="/dashboard" element={<SensitiveRoute><Dashboard /></SensitiveRoute>} />
        <Route path="/detallesclientes/:id" element={<DetallesClientesPage />} />
        <Route path="/ayuda" element={<HelpPage />} />
        <Route path="/registros" element={<Registros />} />
        <Route path="/historico-movimientos" element={<SensitiveRoute><HistoricoMovimientosPage /></SensitiveRoute>} />
        <Route path="/historico-registros" element={<SensitiveRoute><HistoricoRegistrosPage /></SensitiveRoute>} />
        <Route path="/configuracionPage" element={<SensitiveRoute><ConfiguracionPage /></SensitiveRoute>} />
        <Route path="/hsitorico-ventas-por-usuario" element={<SensitiveRoute><HistoricoVentasPorUsuarioPage /></SensitiveRoute>} />
        <Route path="/historico-ventas-por-usuario" element={<SensitiveRoute><HistoricoVentasPorUsuarioPage /></SensitiveRoute>} />
        <Route path="/guarderia" element={<Guarderia />} />
      </Routes>
      <ToastContainer />
    </div>
  );
}

export default App;
